import React, { ComponentType, FC, SVGProps } from 'react';
import TableDataElement from './TableDataElement';
import TableCheckboxCell from './TableCheckboxCell';
import { DeleteIcon, TableEditIcon } from 'src/assets/icons/tools';
import cls from '../Table.module.scss';
import { TableConfig, TableDataItem } from '../types';
interface TableRowProps {
  tableDataItem: TableDataItem;
  config: TableConfig;
  hasActions?: boolean;
  customEditIcon?: ComponentType<SVGProps<SVGSVGElement>> | undefined;
  customDeleteIcon?: ComponentType<SVGProps<SVGSVGElement>> | undefined;
  actionStyles?: string;
}
const TableRow: FC<TableRowProps> = ({
  tableDataItem,
  config,
  hasActions,
  customDeleteIcon: CustomDeleteIcon,
  customEditIcon: CustomEditIcon,
  actionStyles,
}) => {
  return (
    <>
      {config.hasSelection && <TableCheckboxCell id={tableDataItem.data.id} />}
      {config.th.map((thConfig, thConfigIndex) => (
        <TableDataElement
          key={thConfigIndex}
          thConfig={thConfig}
          tableDataItem={tableDataItem}
          thConfigIndex={thConfigIndex}
        />
      ))}
      {hasActions && (
        <td className={actionStyles}>
          <div className={cls['action-row']}>
            {tableDataItem.data.onEdit ? (
              CustomEditIcon ? (
                <CustomEditIcon
                  data-qa-selector={`action-edit-${tableDataItem.data.id}`}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    tableDataItem.data.onEdit?.();
                  }}
                  className="cursor-pointer"
                />
              ) : (
                <TableEditIcon
                  data-qa-selector={`action-edit-${tableDataItem.data.id}`}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    tableDataItem.data.onEdit?.();
                  }}
                  className={cls['action-item']}
                />
              )
            ) : (
              <div className={cls['action-item']} />
            )}
            {tableDataItem.data.onDelete &&
              (CustomDeleteIcon ? (
                <CustomDeleteIcon
                  data-qa-selector={`action-delete-${tableDataItem.data.id}`}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    tableDataItem.data.onDelete?.();
                  }}
                  className="ml-10 cursor-pointer"
                />
              ) : (
                <DeleteIcon
                  data-qa-selector={`action-delete-${tableDataItem.data.id}`}
                  onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    tableDataItem.data.onDelete?.();
                  }}
                  className={cls['action-item']}
                />
              ))}
          </div>
        </td>
      )}
    </>
  );
};

export default TableRow;
